<h2 mat-dialog-title>{{ data?.id && !isCopyMode ? 'Edit user' : 'Add user' }}</h2>
<mat-dialog-content>
  <div class="user-details">
    <app-basic-information [group]="userForm"></app-basic-information>
    <div>
      <h3>Party visibility settings</h3>
      <mat-accordion multi class="user-details__accounts">
        <mat-expansion-panel expanded>
          <mat-expansion-panel-header>
            <mat-panel-title>Parties whose shipments are visible</mat-panel-title>
            <mat-panel-description>
              <mat-icon>list_alt</mat-icon>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <app-parties-table
            [group]="userForm"
            controlName="shipmentsAccess"
            checkboxControlName="canAccessAllCustomers"
            checkboxLabel="Can access all shipments"></app-parties-table>
        </mat-expansion-panel>
        <mat-expansion-panel expanded>
          <mat-expansion-panel-header>
            <mat-panel-title>Parties whose invoices are visible</mat-panel-title>
            <mat-panel-description>
              <mat-icon>receipt_long</mat-icon>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <app-parties-table
            [group]="userForm"
            controlName="invoicesAccess"
            checkboxControlName="canAccessAllInvoices"
            checkboxLabel="Can access all invoices"></app-parties-table>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    @if (entitlements) {
      @for (entitlement of entitlementsConfig; track entitlement.title) {
        <app-selection-list
          [group]="userForm"
          [controlName]="entitlement.controlName"
          [title]="entitlement.title"
          [entitlementList]="entitlements[entitlement.controlName]">
        </app-selection-list>
      }
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  @if (data?.id && !isCopyMode) {
    <button mat-stroked-button [disabled]="saving" (click)="onCopyUser()">Copy User</button>
  }
  <span style="flex: 1"></span>
  <button mat-stroked-button [disabled]="saving" mat-dialog-close>Cancel</button>
  @if (saving) {
    <button mat-flat-button disabled class="saving-button">
      <mat-spinner diameter="18"></mat-spinner>
      Saving
    </button>
  } @else {
    <button
      mat-flat-button
      [disabled]="userForm.invalid || userForm.get('email')?.hasError('emailExists') || saving"
      (click)="save()">
      Save
    </button>
  }
</mat-dialog-actions>
@if (fetchingUserData) {
  <div class="loader">
    <mat-spinner [diameter]="40"></mat-spinner>
    <h3>Fetching user data...</h3>
  </div>
}
